 /* eslint-disable */
import { SET_DAYANTASK_LIST } from './mutation-types'
// import files from 'file-saver'
import api from '@/api'

const state = {
  taskList: {
  },
  taskMessage: {
    list: [],
    listCurrentPage: 1,
    listPageTotal: 0,
    listpageSize: 100
  }

}
const mutations = {
  [SET_DAYANTASK_LIST] (state, payload) {
    state.taskList = payload
  }
}
const actions = {
  // 获取分析or完成分析列表 payload={statusFlag:0,pageNum:1,pageSize:1}
  async getAnalyseTaskList ({ commit, state }, payload) {
    try {
      const data = await api.dayanTaskApi.getAnalyseTaskList(payload)
      commit(SET_DAYANTASK_LIST, data)
    } catch (error) {
      console.log(error)
    }
  },
  // 节点机分布概览
  async showGetNodeList ({}, payload) {
    const {data} = await api.dayanTaskApi.showGetNodeList(payload)
    return data
  },
  // 节点机概览统计数据
  async showNodeData ({}) {
    const {data} = await api.dayanTaskApi.showNodeData()
    return data
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
